import { DateRange, Timestamp } from '@griply/types';
import { differenceInDays } from 'date-fns';

export type BarPosition = {
  left: number;
  width: number;
};

export type GetBarPositionOptions = {
  startDate: Timestamp | null | undefined;
  deadline: Timestamp | null | undefined;
  dateRange: DateRange;
  dayWidth: number;
};

export const getBarPosition = ({
  startDate,
  deadline,
  dateRange,
  dayWidth,
}: GetBarPositionOptions): BarPosition | null => {
  if (!startDate || !deadline) {
    return null;
  }

  const actualStart = new Date(
    Math.min(startDate.getTime(), deadline.getTime()),
  );
  const actualEnd = new Date(Math.max(startDate.getTime(), deadline.getTime()));

  const startDay = differenceInDays(actualStart, dateRange.startDate);
  const endDay = differenceInDays(actualEnd, dateRange.startDate);
  const duration = endDay - startDay;

  return {
    left: startDay * dayWidth,
    width: (duration + 1) * dayWidth,
  };
};
